import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "./navbar";
import { Images } from "../../../lib/images";
import Image from "../../ui/image";
import { ArrowUp } from "lucide-react"; // optional icon (if using lucide-react)

export default function Header() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [showScrollTop, setShowScrollTop] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  const handleLogin = () => {
    void navigate("/analytics");
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setScrolled(scrollY > 0);
      setShowScrollTop(scrollY > 300); // show button after 300px scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="fixed left-0 top-0 z-50 w-full bg-yellow-200 overflow-hidden">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-200 via-yellow-300 to-yellow-200 animate-pulse opacity-70" />
          <div className="relative container mx-auto px-5">
            <div className="flex h-8 md:h-10 items-center justify-center">
              <p className="text-black text-xs md:text-sm font-semibold tracking-wide animate-slide">
                ⚽ La Liga teams to be added soon. Stay tuned!
              </p>
            </div>
          </div>
        </div>
      </div>
      <header
        className={`py-2 px-5 md:py-5 fixed left-0 top-8 md:top-9 w-full z-40 ${
          scrolled ? "bg-foreground shadow-lg" : "bg-transparent shadow-none"
        } transition-all duration-300`}
      >
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex gap-4 items-center justify-between w-full">
            <Link to="/">
              <Image alt="Logo" src={Images.Logo} className="h-8 md:h-10" />
            </Link>
            <Navbar menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

            <div className="flex gap-2 items-center">
              <button
                onClick={handleLogin}
                className="blueButton flex items-center gap-2 uppercase !text-[11px] md:!text-base !px-1 md:!px-5 !leading-snug !py-3"
              >
                Explore Analytics
              </button>

              <button
                className={`bg-green px-0 lg:hidden text-${
                  menuOpen ? "gray-700" : "white"
                } focus:outline-none text-3xl z-30`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                {menuOpen ? "☰" : "☰"}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300 z-50"
          aria-label="Scroll to top"
        >
          <ArrowUp className="w-5 h-5" />
        </button>
      )}
    </>
  );
}
